import * as React from 'react'

export function FormError ({ children }) {
  if (!children) return null

  return <div className="form-error">{children}</div>
}
